/* eslint-disable no-undef */
/* eslint-disable no-empty */
/* eslint-disable no-plusplus */
import _ from 'lodash';

let windowEl = null;
const windowDebounceTime = 400;
const windowListeners = [];
const windowDimensions = { width: 0, height: 0 };
const appVersion = '1.1.1';

export const appendScript = (scriptToAppend) => {
  const script = document.createElement('script');
  script.src = `${scriptToAppend}?v=${appVersion}`;
  script.async = false;
  document.body.appendChild(script);
};

export const removeScript = (scriptToremove) => {
  try {
    const allsuspects = document.getElementsByTagName('script');
    for (let i = allsuspects.length; i >= 0; i--) {
      if (allsuspects[i] && allsuspects[i].getAttribute('src') !== null
        && allsuspects[i].getAttribute('src').indexOf(`${scriptToremove}`) !== -1) {
        allsuspects[i].parentNode.removeChild(allsuspects[i]);
      }
    }
  } catch (e) {}
};

export const loadScript = (scriptName) => {
  removeScript(scriptName);
  appendScript(scriptName);
};

export const scrollToTopAnimated = (timer = 900) => {
  try {
    const funStop = () => {
      $('html, body').stop();
      $(window).off('mousewheel', funStop);
    };

    $(window).on('mousewheel', funStop);

    $('HTML, BODY').animate({
      scrollTop: 0,
    }, timer, () => {
      $(window).off('mousewheel', funStop);
    });
  } catch (e) {}
};

export const scrollToElement = (el = 'HTML, BODY') => {
  $(el).animate({
    scrollTop: 0,
  }, 300);
};

export const initWindowResizeListeners = () => {
  try {
    windowEl = $(window);
    windowDimensions.width = windowEl.width();
    windowDimensions.height = windowEl.height();

    windowEl.on('resize', _.debounce(() => {
      windowDimensions.width = windowEl.width();
      windowDimensions.height = windowEl.height();

      windowListeners.forEach(async cb => cb(windowDimensions));
    }, windowDebounceTime));
  } catch (e) { }
};

export const addWindowResizeCallback = (callback) => {
  const hasListenerIndex = windowListeners.findIndex(list => list === callback);
  if (hasListenerIndex === -1) windowListeners.push(callback);
};

export const removeWindowResizeCallback = (callback) => {
  const hasListenerIndex = windowListeners.findIndex(list => list === callback);
  if (hasListenerIndex !== -1) windowListeners.splice(hasListenerIndex, 1);
};

export const getViewport = (width = windowDimensions.width) => {
  if (width <= 576) return 'xs';
  if (width <= 768) return 'sm';
  if (width <= 992) return 'md';
  if (width <= 1200) return 'lg';
  return 'xl';
};

export const getWindowDimensions = () => {
  try {
    windowDimensions.width = windowEl.width();
    windowDimensions.height = windowEl.height();
  } catch (e) { }

  return windowDimensions;
};

export default {};
